import { VHeaders } from '@/models/pagedlistmodel';

export function getAccountHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'chargeAccount.chargeAccountGridHeaders.name'
      ) as string,
      align: 'left',
      value: 'name',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'chargeAccount.chargeAccountGridHeaders.customerTypeNumber'
      ) as string,
      align: 'left',
      value: 'customerTypeNumber',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'chargeAccount.chargeAccountGridHeaders.accountNumber'
      ) as string,
      align: 'left',
      value: 'accountNumber',
      sortable: true,
    },

    {
      text: vm.$parent.$t(
        'chargeAccount.chargeAccountGridHeaders.action'
      ) as string,
      isNotDataProp: true,
      sortable: false,
      align: 'center',
    },
  ];
}
